export const formatNumberWithCommas = (value: string) => {
  const numericValue = value.replace(/\D/g, "");
  return numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const unformatNumber = (formattedValue: string) => {
  return formattedValue.replace(/,/g, "");
};
